module.exports = __webpack_public_path__ + "img/carrousel-mov-digi-7.83ba1c26.png";